//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"FaceAnalysis",1,0],[0,"PartiallyShaded",1,0],[0,"PointSymbol",1,0],[0,"Translucency",1,0]],[[["type"],"GetColor",{R_:{color:''}},1,1],[["type","color"],"SetColor",{},2,1],[["type","colorSelection"],"GetObjectColor",{R_:{color:''}},1,0],[["type","colorSelection","color"],"SetObjectColor",{},3,0],[["type"],"GetLineFont",{R_:{line_font:''}},1,0],[["type","line_font"],"SetLineFont",{},2,0],[["type"],"GetWidth",{R_:{width:''}},1,0],[["type","width"],"SetWidth",{},2,0],[["color_number"],"ConvertColorNumberToRGBValue",{R_:{fog_color_rgb_value:''}},1,0],[["fog_color_rgb_value"],"ConvertRGBValueToColorNumber",{R_:{color_number:''}},1,0],[["numLegacyWidths","newLineWidths"],"GetLegacyLineWidthMap",{},0,0],[["newLineWidths"],"SetLegacyLineWidthMap",{},1,0],[[],"MigrateLegacyLineWidths",{R_:{migrated:''}},0,0]],[]];
SPLM.Preferences.PartObject = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartObject.ColorSelection = Object.freeze({
    "NoChange" : "NoChange", "DefaultColor" : "DefaultColor", "Color" : "Color"});

SPLM.Preferences.PartObject.ObjectType = Object.freeze({
    "General" : "General", "Line" : "Line", "Arc" : "Arc", "Conic" : "Conic", "Spline" : "Spline", "Solidbody" : "Solidbody", "Sheetbody" : "Sheetbody", "Datum" : "Datum", "Point" : "Point", "CoordinateSystem" : "CoordinateSystem", "AllButDefault" : "AllButDefault", "DatumCsys" : "DatumCsys", "Traceline" : "Traceline", "InfiniteLine" : "InfiniteLine", "PointCloud" : "PointCloud"});

SPLM.Preferences.PartObject.LineFontType = Object.freeze({
    "PartDefault" : "PartDefault", "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

SPLM.Preferences.PartObject.WidthType = Object.freeze({
    "PartDefault" : "PartDefault", "ThinWidth" : "ThinWidth", "NormalWidth" : "NormalWidth", "ThickWidth" : "ThickWidth", "WidthOne" : "WidthOne", "WidthTwo" : "WidthTwo", "WidthThree" : "WidthThree", "WidthFour" : "WidthFour", "WidthFive" : "WidthFive", "WidthSix" : "WidthSix", "WidthSeven" : "WidthSeven", "WidthEight" : "WidthEight", "WidthNine" : "WidthNine"});

export default SPLM;